<div class="nft-ticker d-flex align-items-center">
  <div class="form-group w-100">
    <input type="text" class="form-control" (keyup.enter)="gotoWallet()" placeholder="Search a Wallet" [(ngModel)]="selectedWallet" />
  </div>
</div>